<template>
  <div class="grid">
    <div class="navbar">
      <nav-bar :key="getProjectId"></nav-bar>
    </div>
    <div class="sidebar">
      <sidebar> </sidebar>
    </div>
    <div v-if="!isLogin" class="breadcrumbWrapper">
      <breadcrumb />
    </div>
    <div class="content">
      <router-view :key="getProjectId" />
    </div>
  </div>
</template>

<script>
import mapGettersMixin from '../../mixins/mapGettersMixin'
import Breadcrumb from './BreadcrumbComponent.vue'
import NavBar from './NavBarComponent.vue'
import Sidebar from './SideBarComponent.vue'

export default {
  name: 'LayoutComponent',
  components: {
    Sidebar,
    NavBar,
    Breadcrumb
  },
  mixins: [mapGettersMixin],
  computed: {
    isLogin() {
      return this.currentRouteName == 'Login' //eslint-disable-line
    },
    currentRouteName() {
      return this.$route.name
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

* {
  padding: 0;
  margin: 0;
  font-family: 'Montserrat';
}

body {
  min-height: 100vh;
}

.grid {
  display: grid;
  min-height: inherit;
  grid-template: auto 40px 1fr / minmax(160px, auto) 10% 1fr 10%;
}

.navbar {
  grid-column: 1 / 5;
  grid-row: 1 / 2;
}

.sidebar {
  grid-column: 1 / 2;
  grid-row: 2 / 5;
}

.btn {
  background-color: #8b69a9 !important;
  border: 0px;
}

.body {
  display: grid;
  background-color: aqua;
  place-items: center;
}

.breadcrumbWrapper {
  grid-column: 3;
  grid-row: 2;
  overflow: hidden;
  min-width: 0%;
  padding-bottom: 20px;
}

.content {
  display: flex;
  justify-content: center;
  grid-column: 3 / 4;
  grid-row: 3 / 6;
}
</style>
